<template>
  <form class="register-form">
    <div class="text-center mb-4" v-if="state.email">
      <v-chip color="primary" variant="tonal" size="large">
        {{ state.email }}
      </v-chip>
    </div>
    <v-text-field
      v-model="state.password"
      label="New Password"
      required
      :type="showPassword ? 'text' : 'password'"
      variant="outlined"
      prepend-inner-icon="mdi-lock"
      :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
      density="comfortable"
      class="mb-4"
      @click:append-inner="showPassword = !showPassword"
    ></v-text-field>
    <div class="text-center mb-4">
      <v-otp-input v-model="state.code" length="6" variant="outlined"></v-otp-input>
    </div>

    <v-btn
      block
      size="large"
      color="primary"
      variant="elevated"
      @click="onClickConfirm"
      :loading="state.loading"
      :disabled="state.code.length !== 6 || !state.password"
      class="mb-4"
    >
      Reset Password
    </v-btn>

    <v-divider class="my-4"></v-divider>

    <div class="text-center">
      <RouterLink :to="URLs.PAGE_AUTH_LOGIN" class="text-decoration-none text-primary">
        Back to Login
      </RouterLink>
    </div>
  </form>
</template>

<script setup lang="ts">
import { URLs } from "@/constants";
import { useAuthStore } from "@/stores/auth";
import { makeAlert } from "@/utils";
import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";

const authStore = useAuthStore();
const router = useRouter();
const route = useRoute();

const state = ref({
  email: (route.query.email as string) || "",
  password: "",
  code: "",
  loading: false
});

const showPassword = ref(false);

const onClickConfirm = async () => {
  state.value.loading = true;
  const response = await authStore.confirmPasswordReset({
    email: state.value.email,
    password: state.value.password,
    code: state.value.code
  });
  state.value.loading = false;

  if (response.status) {
    makeAlert("Password reset success", "success");
    router.push({
      path: URLs.PAGE_AUTH_LOGIN,
      query: {
        email: state.value.email
      }
    });
  } else {
    makeAlert(response.message, "error");
  }
};
</script>
